import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function DownloadIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M12 17V3M20 21H4M17 12L11.999 17.001L6.999 12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
